import { defineMessages } from '@alltrails/shared/react-intl';

const ABOUT_PAGE_STRINGS = defineMessages({
  ABOUT: {
    defaultMessage: 'About AllTrails'
  },
  CONNECT_OUTDOORS: {
    defaultMessage: 'We connect people to the outdoors'
  },
  ABOUT_HERO_ALT: {
    defaultMessage: 'Two people hiking up rocky terrain while holding hands'
  },
  SIGN_UP_FREE: {
    defaultMessage: 'Sign up for free'
  },
  UPGRADE_TO_PRO: {
    defaultMessage: 'Upgrade to Pro'
  },
  NAV_WHO_WE_ARE: {
    defaultMessage: 'Who we are'
  },
  NAV_OUR_VALUES: {
    defaultMessage: 'Our values'
  },
  NAV_OUR_CULTURE: {
    defaultMessage: 'Our culture'
  },
  NAV_GIVING_BACK: {
    defaultMessage: 'Giving back'
  }
});

export default ABOUT_PAGE_STRINGS;
